import { render, staticRenderFns } from "./EditCenter.vue?vue&type=template&id=6e499a76&scoped=true&"
import script from "./EditCenter.vue?vue&type=script&lang=js&"
export * from "./EditCenter.vue?vue&type=script&lang=js&"
import style0 from "./EditCenter.vue?vue&type=style&index=0&id=6e499a76&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e499a76",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VCol,VIcon,VRow,VSwitch,VTextField,VTooltip})
